import React from 'react'
import { formatPositionStatus } from '../../helpers/formatters/order-position'

import { Tag } from 'rsuite'

export interface CommonOrderPositionStatusLabelProps {
  status: number
}

export default function CommonOrderPositionStatusLabel ({
  status
}: CommonOrderPositionStatusLabelProps) {
  const { label, color = null } = formatPositionStatus(status)
  return (
    <Tag className="u-status-badge" color={color}>
      {label}
    </Tag>
  )
}
